import { useBrowsePresetApi } from '@aibees/shared/api';
import { MORE_FILTERS_PRESET_TYPE } from '../constants';
import { FilterSettings } from '../store';

export function useBrowseMoreFilters() {
  return useBrowsePresetApi<FilterSettings>({
    type: MORE_FILTERS_PRESET_TYPE,
    name: MORE_FILTERS_PRESET_TYPE,
    size: 1,
  });
}
